Your SipSignal Service may be cancelled at any time by providing SipSignal with
a notice of your intent to cancel by sending an email to
<a href="mailto:service@sipsignal.com">service@sipsignal.com</a> or calling our
Customer Care Department at <a href="tel:+1-718-989-9833">1-718-989-9833</a>.
<br /><br />
Money Back Guarantee. If you are unsatisﬁed with your SipSignal service for any
reason in the ﬁrst 30 days after your initial sign up, under the condition that
you did not receive a free device, and you are not subject to a minimum
commitment contract (such as a SipSignal Service Agreement), you may cancel and
be eligible for a refund of equipment, activation and subscription fees.
Shipping and handling charges are not refundable. Refunds for devices where an
RMA was requested within the 30 day period will be made in full if the devices
are in "returnable" condition and the device is returned within 7 days of the
RMA date. Returnable condition requires the item to be in new condition, in the
original packaging and all parts and documentation received. Return shipping is
the customer responsibility. <br />
Our money back guarantee does not apply to customers who received a free device,
minimum commitment contracts, any charges for international usage, payphone
calls to SipSignal toll free numbers, and directory assistance. Our money back
guarantee also does not apply to any renewals or add-on lines or services added
after your initial order. In addition, we may not be able to refund all of the
taxes that you paid. SipSignal will use commercially reasonable efforts to
refund promptly any charges (less any amounts that you owe to us) to your
account following the return of your device. If your device is not returned
within 14 days from the RMA date, SipSignal will refund you for all eligible
charges except for the device charges. Once the device is returned, the device
charges will be refunded less any applicable restock fee. <br /><br /><br />
A charge for the retail price of any device will be made to the customer's
account if the device is not returned within 14 days of the RMA date.
<br /><br />
WE HAVE THE RIGHT TO REVOKE THE MONEY BACK GUARANTEE FOR ALL CUSTOMERS AT ANY
TIME WITHOUT PRIOR NOTICE. <br /><br />
The 30-Day Money Back Guarantee does not apply if you are found to be in
violation of our terms of service or if you have taken advantage of the
guarantee in the past. <br /><br />
Termination After 30 Days. Upon termination of service after the initial 30
days, the termination will be effective on the last day of the current billing
period in which notice of termination is given (not applicable to minimum
commitment contracts). At any time, and for any reason, SipSignal may provide a
refund, discount, or other consideration to a SipSignal customer ("Credit"). The
amount and form of a Credit, and the decision to provide them, are at
SipSignal's sole and absolute discretion. The provision of a Credit is one
instance that does not entitle you to a Credit in the future for similar
instances, nor does it obligate SipSignal to provide a Credit in the future,
under any circumstances. Equipment is not returnable or refundable after the
30-Day Money Back Guarantee period. <br /><br />
Non-usage of service does not constitute cancellation of service nor does it
extend the 30-Day Money Back Guarantee period. Minimum Commitments Contracts. In
the event you signed up for a minimum commitment contract, in addition to any
disconnect fee, you will be responsible for all charges for the entire minimum
commitment period and authorize SipSignal to bill these fees to your payment
method (credit card). The 30-Day Money Back Guar- antee does not apply to any
executed minimum commitment contract. <br /><br />
Porting. You may be able to take, or "port," your current number to another
service provider. There will be $15 port out fee per number. Once your port is
completed through your new service provider, you must email
service@SipSignal.com to cancel your SipSignal Service. Until you cancel service
with SipSignal, you will remain a SipSignal customer, and you will continue to
be responsible for all charges and fees associated with your Service. If you
cancel your Service prior to completion of the port, your Service will not work
and your number may not be available for porting. Your account must be active
and in good standing in order to port out your number.
